export default __webpack_public_path__ + "static/media/photo-03.9942caf6.jpeg";